import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'src/app/shared/message/message.service';
import { UserService } from 'src/app/user/user.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss'],
  standalone: false
})
export class ForgetPasswordComponent implements OnInit {
  private userService = inject(UserService);
  private router = inject(Router);
  private messageService = inject(MessageService);

  recoverForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  });
  isLoading = false;
  error = null;

  ngOnInit() {}

  sendEmail() {
    if (!this.recoverForm.valid) {
      return;
    }
    this.isLoading = true;
    this.error = null;
    const email = this.recoverForm.get('email').value;
    this.userService.forgetPassword(email).subscribe({
      next: () => {
        this.isLoading = false;
        this.router.navigate(['']);
        this.messageService.message =
          'ถ้าอีเมลนี้เป็นสมาชิก คุณจะได้รับอีเมลเพื่อเปลี่ยนรหัสผ่านใหม่ภายใน 2-3 นาที';
      },
      error: (err) => {
        this.isLoading = false;
        this.error = err?.error?.message;
      }
    });
  }
}
